import moment from "moment";
import { apiURL } from "../../config";

export async function getUpperDecisionList(axiosPrivate, unitId, matterID, date, phrase) {
	const matterIdURL = matterID ? `&matterId=${matterID}` : "";
	const dateURL = date ? `&date=${moment(date).format("YYYY-MM-DD")}` : "";
	const phraseURL = phrase ? `&phrase=${phrase}` : "";
	return axiosPrivate
		.get(`${apiURL}/decision/maker/upper-decision-list.json?unitId=${unitId}${matterIdURL}${dateURL}${phraseURL}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}
